module.exports = __webpack_public_path__ + "img/sunday-bm.jpeg";